export const ACCOUNT_STATUS_INITIAL = "initial";
export const ACCOUNT_STATUS_LOADING = "loading";
export const ACCOUNT_STATUS_LOADED = "loaded";